"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsInBeta = void 0;
const AtmsApiClient_1 = __importDefault(require("../utils/AtmsApiClient"));
const query_string_1 = require("query-string");
const react_1 = require("react");
const usePref_1 = __importDefault(require("./usePref"));
exports.useIsInBeta = (betaName) => {
    const [value, setValue] = usePref_1.default(`isInBeta${betaName ? `/${betaName}` : ''}`, false);
    react_1.useEffect(() => {
        AtmsApiClient_1.default.httpGet(`/api/betaStatus?${query_string_1.stringify({ betaName })}`)
            .then(result => {
            setValue(result);
        })
            .catch(e => {
            console.warn('Failed to get beta status', e);
        });
    }, [betaName]);
    return {
        isInBeta: value,
        setIsInBeta: (optIn) => {
            return AtmsApiClient_1.default.httpPut('/api/betaStatus', { betaName, optIn })
                .then(result => {
                setValue(result);
                return result;
            })
                .catch(e => {
                console.warn('Failed to update beta status', e);
            });
        },
    };
};
//# sourceMappingURL=useIsInBeta.js.map